import { render, staticRenderFns } from "./ModalSelectReason.vue?vue&type=template&id=18e42cb0&scoped=true"
import script from "./ModalSelectReason.vue?vue&type=script&lang=js"
export * from "./ModalSelectReason.vue?vue&type=script&lang=js"
import style0 from "./ModalSelectReason.vue?vue&type=style&index=0&id=18e42cb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e42cb0",
  null
  
)

export default component.exports